module.exports = __webpack_public_path__ + "img/blog7-1.5de7c343.webp";